module.exports = __webpack_public_path__ + "media/static/notify-be634e688b52e78db59a93b7e4bb591c.wav";